import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Order, OrderDetail } from '../../models/orders.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnsModel, LineItem, ReturnData } from '../../models/returns.model';
import { AuthService } from '../../services/auth.service';
import { PaymentApiResponse } from '../../models/check-out.model';
import { BulkInvoice, Invoice } from '../../models/orders.model';

@Injectable()
export class MyoderService {

  base_url: string = "api/MyOrder";
  pageNo: number = 1;
  order:Order = {} as Order;
  paymentApiResponse: PaymentApiResponse = {} as PaymentApiResponse;
  bulkInvoice: BulkInvoice = {} as BulkInvoice;

  private watchSearchSubject = new BehaviorSubject<string>("");
  currentWatch = this.watchSearchSubject.asObservable();

  private watchOrderDetaiSubject = new BehaviorSubject<Order>(this.order);
  currentOrderDetaiWatch = this.watchOrderDetaiSubject.asObservable();

  private watchPaymentSubject = new BehaviorSubject<PaymentApiResponse>(this.paymentApiResponse);
  currentPaymentWatch = this.watchPaymentSubject.asObservable();

  private watchBulkInvSubject = new BehaviorSubject<BulkInvoice>(this.bulkInvoice);
  currentBulkInvWatch = this.watchBulkInvSubject.asObservable();


  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  monitorSearchKeyWordChange(searchKeyWord: string): void {
    this.watchSearchSubject.next(searchKeyWord);
  }

  monitorOrderDetaiChange(order: Order): void {
    this.watchOrderDetaiSubject.next(order);
  }

  monitorPaymentChange(payment: PaymentApiResponse): void {
    this.watchPaymentSubject.next(payment);
  }

  monitorBulkInvChange(bulkInvoice: BulkInvoice): void {
    this.watchBulkInvSubject.next(bulkInvoice);
  }

  public openOrders$ : BehaviorSubject<Order[]> = new BehaviorSubject<Order[]>(null);

  // getOpenOrders(pageNo: number): Observable<Order[]> {
  //   return this.http.get(this.base_url + "/GetOpenOrders?pageNo=" + pageNo)
  //     .pipe(catchError(this.handleError));
  // }
  getOpenOrders(): Observable<Order[]> {
    return this.http.get<Order[]>(this.base_url + "/GetOpenOrders")
      .pipe(catchError(this.handleError));
  }

  getSearchOrders(orderSearch: string, pageNo: number): Observable<Order[]> {
    return this.http.get<Order[]>(this.base_url + "/GetSearchedOrder?orderSearch=" + orderSearch + "&pageNo=" + pageNo)
      .pipe(catchError(this.handleError));
  }

  getBackOrder(pageNo: number): Observable<Order[]> {
    return this.http.get<Order[]>(this.base_url + "/GetBackOrders?pageNo=" + pageNo)
      .pipe(catchError(this.handleError));
  }

  // getShippedOrders(pageNo: number): Observable<Order[]> {
  //   return this.http.get(this.base_url + "/GetShippedOrders?pageNo=" + pageNo)
  //     .pipe(catchError(this.handleError));
  // }
  getShippedOrders(searchKey:string): Observable<Order[]> {
    return this.http.get<Order[]>(this.base_url + "/GetShippedOrders?searchKey=" + searchKey)
      .pipe(catchError(this.handleError));
  }

  getBackOrderDetailsView(orderNumber: string): Observable<OrderDetail> {
    return this.http.get<OrderDetail>(this.base_url + '/GetBackOrderDetailsView?orderNumber=' + orderNumber)
      .pipe(catchError(this.handleError));
  }

  GetOrderDetails(orderNumber: string, orderSuffix: string): Observable<OrderDetail> {
    return this.http.get<OrderDetail>(this.base_url + '/GetOrderDetails?orderNumber=' + orderNumber + "&orderSuffix=" + orderSuffix)
      .pipe(catchError(this.handleError));
  }

  getReturnOrderDetails(orderNumber: string, orderSuffix: string): Observable<LineItem[]> {
    return this.http.get<LineItem[]>(this.base_url + '/GetReturnOrderDetails?orderNumber=' + orderNumber + '&orderSuffix=' + orderSuffix)
      .pipe(catchError(this.handleError));
  }

  getReturnsDropdownLists(): Observable<ReturnsModel> {
      return this.http.get<ReturnsModel>(this.base_url + '/GetReturnsDropdownLists')
        .pipe(catchError(this.handleError));
  }

  exportExportOrderSerials(orderNumber: string, orderSuffix: string): Observable<any> {
    orderSuffix = orderSuffix != null ? orderSuffix : '';
    return this.http.get('/api/ExportExcel/ExportOrderSerials?orderNumber=' + orderNumber + '&orderSuffix=' + orderSuffix,
    { responseType: 'blob', headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'} })
    .pipe(catchError(this.authService.handleError));
  }

  returnsGetData(returnData: ReturnData, attachment: File): Observable<any> {

    // let options = new RequestOptions({
    //   headers: new Headers({
    //     'Access-Control-Cross-Origin': '*'
    //   })
    // });

    //headers.append('Content-Type', 'multipart/form-data');
    //headers.append('Accept', 'application/json');

    let formData = new FormData();
    if (attachment != null || attachment != undefined) {
      formData.append(attachment.name, attachment);
    }

    formData.append('returnData', JSON.stringify(returnData));

    return this.http.post(this.base_url + '/ReturnsGetData', formData)
      .pipe(catchError(this.handleError));
  }

  GetBulkInvoices(requestString: string): Observable<Invoice[]> {

    let formData = new FormData();

    formData.append('requestString', requestString);

    return this.http.post<Invoice[]>(this.base_url + '/GetBulkInvoices', formData)
      .pipe(catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {

    console.error('server error:', error);
    if (error.error instanceof ErrorEvent) {
      let errMessage = '';
      try {
        errMessage = error.error.message;
      } catch (err) {
        errMessage = error.statusText;
      }
      return Observable.throw(errMessage);
    }
    return Observable.throw(error.error || 'ASP.NET Core server error');
  }

}
